import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { MbscNotificationsModule } from '@mobiscroll/angular';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MbscEventcalendar } from '@mobiscroll/angular';
import { provideHttpClient, withJsonpSupport } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';

window.mobiscroll = MbscEventcalendar;

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideAnimations(),
    provideAnimationsAsync(),
    ...appConfig.providers,
    importProvidersFrom(MbscNotificationsModule),
    provideHttpClient(withJsonpSupport()),
    provideRouter(routes) 
  ]
}).catch((err) => console.error(err));